<template>
  <div class="container">
    <section id="editContent" class="columnContainer">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.nav_admin}} <span v-if="!!admin">&#8250; {{current}}</span></h1>
        <router-view :locale="locale" />
      </div>
      <div class="innerSide"><div class="sideBox">
        <div class="pageNav">
          <router-link v-if="partner !== 'NSJ'" :to="{name: 'serviceinfo', params: {admin: 'serviceinfo'}}" class="mb15 btn btnFull btnWhite">{{locale.admin_serviceinfo}}</router-link>
          <router-link :to="{name: 'userlist', params: {admin: 'userlist'}}" class="mb15 btn btnFull btnWhite">{{locale.admin_userlist}}</router-link>
          <router-link :to="{name: 'codelist', params: {admin: 'codelist'}}" class="mb15 btn btnFull btnWhite">{{locale.admin_codelist}}</router-link>
          <router-link :to="{name: 'submitcategory', params: {admin: 'submitcategory'}}" class="mb15 btn btnFull btnWhite">{{locale.admin_submitcategory}}</router-link>
          <router-link :to="{name: 'pidtype', params: {admin: 'pidtype'}}" class="mb15 btn btnFull btnWhite">{{locale.pidtype}}</router-link>
          <!-- <router-link :to="{name: 'payment', params: {admin: 'payment'}}" class="mb15 btn btnFull btnWhite">{{locale.admin_payment}}</router-link> -->
        </div>
      </div></div>
    </section>
    <div id="setContent">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Admin',
  props: [
    'locale'
  ],
  computed: {
    admin () {
      return this.$route.params.admin
    },
    current () {
      const name = `admin_${this.admin}`
      return this.locale[name]
    },
    partner () {
      return this.$store.state.service.partner
    }
  },
  watch: {
    '$route' (to, from, next) {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
